import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.machine-tasks-show-page, .agro-operations-show-page', () => {
  import('./internal/machine-tasks-show-page__agro-operations-show-page').then(({ default: Component }) => Component());
});
